// extracted by mini-css-extract-plugin
export default {"main_container":"SplashScreen_main_container__PsPKV"};